
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { AppComponent } from './app.component';
import { ContentLayoutComponent } from './layouts/content/content-layout.component';
import { FullLayoutComponent } from './layouts/full/full-layout.component';

import { AuthGuard } from './shared/auth/auth-guard.service';
import { AuthenticationService } from 'services/authentication.service';
import { AlertService } from 'services/alert.service';
import { UserSessionService } from 'services/usersession.service';
import { DataService } from 'services/data.service';
import { HttpInterceptorService } from 'services/interceptor.service';
import { NavigationService } from 'services/navigation.service';
import { CoverageService } from 'services/coverage.service';
import { ToastrModule } from 'ngx-toastr';
import { UserService } from 'services/user.service';
import { ApplicationService } from 'services/application.service';

import { ForgotpasswordComponent } from './pages/content-layout-page/login/forgotpassword.component';
import { ForgotpasswordModule } from './pages/content-layout-page/login/forgotpassword.module';
import { ChangepasswordComponent } from './pages/content-layout-page/changepassword/changepassword.component';
import { ChangepasswordModule } from './pages/content-layout-page/changepassword/changepassword.module';
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { CheckcoverageComponent } from './pages/content-layout-page/checkcoverage/checkcoverage.component';
import { CheckcoverageModule } from './pages/content-layout-page/checkcoverage/checkcoverage.module';
import { WifidetailsComponent } from './pages/full-layout-page/wifidetails/wifidetails.component';
import { WifidetailsModule } from './pages/full-layout-page/wifidetails/wifidetails.module';
import { UpdatewifidetailsComponent } from './pages/full-layout-page/updatewifidetails/updatewifidetails.component';
import { UpdatewifidetailsModule } from './pages/full-layout-page/updatewifidetails/updatewifidetails.module';
import { CancellationofserviceComponent } from './pages/full-layout-page/cancellationofservice/cancellationofservice.component';
import { CancellationofserviceModule } from './pages/full-layout-page/cancellationofservice/cancellationofservice.module';
import { ChangeofserviceComponent } from './pages/full-layout-page/changeofservice/changeofservice.component';
import { ChangeofserviceModule } from './pages/full-layout-page/changeofservice/changeofservice.module';
import { PdfviewerpageComponent } from './pages/full-layout-page/pdfviewerpage/pdfviewerpage.component';
import { PdfviewerpageModule } from './pages/full-layout-page/pdfviewerpage/pdfviewerpage.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BrowserModule } from '@angular/platform-browser';
import { ActiveUserSessionService } from 'services/activeusersession.service';
import { ProductService } from 'services/product.service'
import { ActiveUserSession } from 'models/activeusersession';
import { DatePipe } from '@angular/common';
import { ChangeRequestModelModule } from './pages/full-layout-page/changeofservice/changerequestmodel.module';
import { ChangeRequestModelComponent } from './pages/full-layout-page/changeofservice/changerequestmodel.component';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { InformationModule } from './pages/content-layout-page/information/information.module';
import { DashboardpopupModule } from './pages/full-layout-page/dashboardpopup/dashboardpopup.module';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { SpinnerComponent } from './shared/component/spinnercomponent/spinner.component';
import { MyprofileModule } from './pages/full-layout-page/myprofile/myprofile.module';
import { ManageorderModule } from './pages/full-layout-page/manageorder/manageorder.module';
import { ScrollService } from 'services/scroll.service';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { OtherlocationaddressModule } from './pages/content-layout-page/otherlocationaddress/otherlocationaddress.module';
import { OtherlocationaddressComponent } from './pages/content-layout-page/otherlocationaddress/otherlocationaddress.component';
import { ChartsModule } from 'ng2-charts';
import { ProductinformationModule } from './pages/content-layout-page/productinformation/productinformation.module';
import { ProductinformationComponent } from './pages/content-layout-page/productinformation/productinformation.component';
import { UpdateService } from 'services/update.service';
import { RegisterbyreferenceModule } from './pages/content-layout-page/registerbyreference/registerbyreference.module';
import { ReferFriendsModule } from './pages/full-layout-page/referfriends/referfriends-list/referfriends.module';
import { FriendDetailsService } from 'services/frienddetails.service';
import { ManagepayoutsModule } from './pages/full-layout-page/managepayouts/managepayouts.module';
import { ManagepayoutModule } from './pages/full-layout-page/managepayouts/managepayout.module';
import { ManagecreditpopupComponent } from './pages/full-layout-page/managecreditpopup/managecreditpopup.component';
import { ManagecreditpopupModule } from './pages/full-layout-page/managecreditpopup/managecreditpopup.module';
import { CustomerreportModule } from './pages/full-layout-page/customerreport/customerreport.module';
import { ExcelService } from 'services/excel.service';
import { RedeempopupModule } from './pages/full-layout-page/redeempopup/redeempopup.module';
import { RedeempopupComponent } from './pages/full-layout-page/redeempopup/redeempopup.component';
import { UserBankDetailsService } from 'services/userbankdetails.service';
import { CustomeramendmentModule } from './pages/full-layout-page/customeramendment/customeramendment.module';
import { VumatelapplicationhistoryModule } from './pages/full-layout-page/vumatelapplicationhistory/vumatelapplicationhistory.module';
import { SalesreppopupComponent } from './pages/full-layout-page/salesreppopup/salesreppopup.component';
import { SalesreppopupModule } from './pages/full-layout-page/salesreppopup/salesreppopup.module';
import { ResalepageComponent } from './pages/full-layout-page/resalepage/resalepage.component';
import { ResalepageModule } from './pages/full-layout-page/resalepage/resalepage.module';
import { MatDatepickerModule } from '@angular/material/datepicker'
import { ZoomactivatepopupModule } from './pages/full-layout-page/zoomactivatepopup/zoomactivatepopup.module';
import { ValoginModule } from './pages/full-layout-page/valogin/valogin.module';
import { ManageUserModule } from './pages/full-layout-page/manageuser/manageuser.module';
import { EFTAttachModule } from './pages/full-layout-page/eftattach/eftattach.module';
import { ManageCommunicationModule } from './pages/full-layout-page/managecommunication/managecommunication.module';
import { VoucherModule } from './pages/full-layout-page/voucher/voucher.module';
import { VoucherService } from 'services/voucher.service';
import { ReactiveFormsModule } from '@angular/forms';
import { ManageOtpNotificationModule } from './pages/full-layout-page/manageotpnotification/manageotpnotification.module';
import { SupportTicketComponent } from './pages/full-layout-page/support-ticket/support-ticket.component';
import { SupportTicketModule } from './pages/full-layout-page/support-ticket/support-ticket.module';
import { SupportStatusModule } from './pages/full-layout-page/support/support-status/support-status.module';
import { AddSupportModule } from './pages/full-layout-page/support/add-support/add-support.module';
import { SupportTicketAdminModule } from './pages/full-layout-page/support/support-ticket-admin/support-ticket-admin.module';
import { ReferFriendsBannerComponent } from './pages/full-layout-page/referfriends/referfriends-banner-dailog/referfriends-banner-dailog.component';
import { AddLoginModule } from './pages/full-layout-page/add-login/add-login.module';
import { ManageReferralModule } from './pages/full-layout-page/referfriends/manage-referral/manage-referral.module';
import { InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false
};


export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.Microsoft.clientId,
      authority: environment.Microsoft.authority,
      redirectUri: environment.Microsoft.redirectUri,
      navigateToLoginRequestUrl: false
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    }
  });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['openid', 'profile', 'email']
    }
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
  // Add your API URL here to ensure tokens are attached to calls
  // protectedResourceMap.set('https://dev.home-connect.co.za/HomeWebapi/*', ['openid', 'profile', 'email']); // Usually you'd use a specific API scope here

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
const DATEFNS_FORMATS_EN_LOCALE = {
  parseInput: 'dd/MM/yyyy HH:mm || dd/MM/yyyy HH:mm', // multiple date input types separated by ||
  fullPickerInput: 'dd/MM/yyyy HH:mm',
  datePickerInput: 'dd/MM/yyyy HH:mm',
  timePickerInput: 'HH:mm',
  monthYearLabel: 'MMM yyyy',
  dateA11yLabel: 'dd/MM/yyyy HH:mm',
  monthYearA11yLabel: 'MMMM yyyy',
};
@NgModule({
  declarations: [AppComponent, FullLayoutComponent, ContentLayoutComponent],
  imports: [
    BrowserAnimationsModule,
    ReactiveFormsModule,
    ChartsModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    NgHttpLoaderModule,
    OwlDateTimeModule,
    IvyCarouselModule,
    OwlNativeDateTimeModule,
    ForgotpasswordModule,
    ChangeRequestModelModule,
    MatDatepickerModule,
    ChangepasswordModule,
    CheckcoverageModule,
    WifidetailsModule,
    UpdatewifidetailsModule,
    CancellationofserviceModule,
    MyprofileModule,
    ManageorderModule,
    ManageCommunicationModule,
    ManageUserModule,
    ChangeofserviceModule,
    ZoomactivatepopupModule,
    ValoginModule,
    EFTAttachModule,
    PdfviewerpageModule,
    BrowserModule,
    PdfViewerModule,
    InformationModule,
    DashboardpopupModule,
    PdfViewerModule,
    OtherlocationaddressModule,
    ProductinformationModule,
    ReferFriendsModule,
    ManageReferralModule,
    ManageOtpNotificationModule,
    SupportTicketModule,
    SupportStatusModule,
    SupportTicketAdminModule,
    AddSupportModule,
    AddLoginModule,
    VoucherModule,
    RegisterbyreferenceModule,
    ManagepayoutsModule,
    ManagepayoutModule,
    ManagecreditpopupModule,
    RedeempopupModule,
    CustomerreportModule,
    CustomeramendmentModule,
    VumatelapplicationhistoryModule,
    SalesreppopupModule,
    ResalepageModule,
    ScrollToModule.forRoot(),
    NgbModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBbHlZ2lyrZtAqRX2sFO1riNdvKaSmfo4w'
    }),
    AgmSnazzyInfoWindowModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    PerfectScrollbarModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    MsalModule.forRoot(
      MSALInstanceFactory(),
      MSALGuardConfigFactory(),
      MSALInterceptorConfigFactory()
    )
  ],
  providers: [
    AuthGuard,
    AuthenticationService,
    ActiveUserSession,
    AlertService,
    UserService,
    UserSessionService,
    ActiveUserSessionService,
    NavigationService,
    ProductService,
    ApplicationService,
    DataService,
    CoverageService,
    ScrollService,
    UpdateService,
    VoucherService,
    FriendDetailsService,
    ExcelService,
    UserBankDetailsService,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalGuard,
    MsalService,
    MsalBroadcastService
  ],
  exports: [
    HttpClientModule,
    MatDatepickerModule
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
  entryComponents:
    [
      ResalepageComponent,
      SalesreppopupComponent,
      ForgotpasswordComponent,
      ChangepasswordComponent,
      PdfviewerpageComponent,
      ChangeRequestModelComponent,
      ReferFriendsBannerComponent,
      SpinnerComponent,
      OtherlocationaddressComponent,
      ProductinformationComponent,
      ManagecreditpopupComponent,
      RedeempopupComponent
    ]
})
export class AppModule { }
